import { ENDPOINT_IFP_APPLICATION_RETURN_OR_CANCEL_ACTION, IfpApplicationAction } from '@shared/sec-loans'
import { GetDataStep } from '@ui-common/steps/GetDataStep/GetDataStep'
import { callEndpoint } from '@ui-common/utils/http/client'
import { JSX } from 'react'
import { useIntl } from 'react-intl'
import { ActorRef, Snapshot } from 'xstate'

const ReturnApplicationStep = (props: {
  parentService: ActorRef<Snapshot<unknown>, { type: 'APPLICATION_RETURNED' }>
  applicationId: string
  onAbort?: () => unknown
}): JSX.Element => {
  const intl = useIntl()

  const { parentService, applicationId } = props

  return (
    <GetDataStep
      getDataCallback={() => {
        return callEndpoint(ENDPOINT_IFP_APPLICATION_RETURN_OR_CANCEL_ACTION, {
          pathParams: { applicationId, action: IfpApplicationAction.Return },
        })
      }}
      heading={intl.formatMessage({ id: 'common-loading' })}
      onAbort={props.onAbort}
      callbacks={{ proceed: () => parentService.send({ type: 'APPLICATION_RETURNED' }) }}
    />
  )
}

export default ReturnApplicationStep
